import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState, ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionKey, setTransitionKey] = useState(location.pathname);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      prevPathRef.current = location.pathname;
      setTransitionKey(location.pathname);
      setDisplayChildren(children);
      // Scroll to top on navigation
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [location.pathname, children]);

  return (
    <div key={transitionKey} className="page-transition-enter w-full">
      {displayChildren}
    </div>
  );
}
